import cx from 'classnames';
import PropTypes from 'prop-types';

import './OnOffButton.scss';

const propTypes = {
  active: PropTypes.bool,
  onClick() {},
};

const defaultProps = {
  active: false,
  onClick() {},
};

function OnOffButton({ active, onClick, ...props }) {
  const className = cx('OnOffButton', { 'OnOffButton--active': active });
  return <button type="button" {...props} className={className} onClick={onClick} />;
}

OnOffButton.propTypes = propTypes;
OnOffButton.defaultProps = defaultProps;

export default OnOffButton;
